"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[8774],{

/***/ 8774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SlideCart)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function SlideCart({ wrapper }) {
  const urls = {
    cartUpdate: '/cart/update.js',
    cartChange: '/cart/change.js',
    cartAdd: '/cart/add.js',
    cartGet: '/cart.json',
  };


  const settings = {
    slideCartContainer: '[data-priority-module="slide-cart"]',
    slideCartInner: '[data-hook="inner-cart"]',
    
    closeCart: '[data-hook="cart-close"]',
    openCart: '[data-hook="open-cart"]',
    cartCount: '[data-hook="cart-count"]',

    productForm: "form[action='/cart/add']",
    removeItem: '[data-hook="remove-item"]',
    itemQuantity: '[data-hook="item-quantity-input"]',
    quantityButton: '[data-hook="change-quantity"]',

    cartNoteToggle: '[data-hook="cart-note-toggle"]',
    cartNoteTextarea: '[data-hook="cart-note-textarea"]',
    cartNoteTextareaWrapper: '[data-hook="cart-note-textarea-container"]',
    cartNoteLabel: '[data-hook="cart-note-label"]',
    cartNoteSaveButton: '[data-hook="save-cart-note"]',
    cartNoteEditButton: '[data-hook="cart-note-edit"]',
    cartNoteCancelButton: '[data-hook="clear-cart-note"]',
    cartNoteCharLimit: '[data-hook="cart-note-limit"]',
    checkoutButton: '[data-hook="process-checkout"]',
    shippingIndicatorBar: '[data-hook="cart-shipping-indicator"]',
    
    cartSubscribeButton: '[data-sub-upgrade]',
    cartSubscriptionFrequencySelect: 'select[name="frequency"]',
  };


  const config = {
    isCartPage: location.pathname.includes('/cart'),
    $elementToFocusOnCartClose: jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCart),
    cartSectionID: '',
    activeClass: 'tw-activated',

  };
  


  ;(function init() {
    // Handle Standard Cart Page ('/cart')
    if (!!config.isCartPage) {
      configureCartPage()

    // Handle Global Slide Cart
    } else {
      configureSlideCart()
    }
    
    initializeEventListeners()

    
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')
    if (new URL(location).searchParams.has('open_cart')) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:open')
    }
  })()




  function configureCartPage() {
    // * TS - NOTE: As of ~Q1 2024, Branch Basics no longer uses the /cart page, and instead redirects users trying to access the /cart page to '/?open_cart'
    config.cartSectionID = ''
  }

  function configureSlideCart() {
    config.cartSectionID = 'ajax-cart'
  }



  function initializeEventListeners() {
    // * If /cart Page, we are still handling w/ legacy cartPage.js
    if (location.pathname !== '/cart') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cart:build', buildCart);
      
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).off('cart:open').on('cart:open', toggleCart);
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).off('cart:close').on('cart:close', toggleCart);
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).off('cart:toggle').on('cart:toggle', toggleCart);

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown', (e) => {
        const keyIsEscape = e.originalEvent.key == 'Escape'
        const cartIsOpen = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass('activated')

        if (keyIsEscape && cartIsOpen) {
          ;() => jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:close')
        }
      })
    }


    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', settings.closeCart, () => jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:close'))
    
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', settings.removeItem, handleItemRemove)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', settings.checkoutButton, processCheckout)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', settings.itemQuantity, adjustItemQuantity)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', settings.quantityButton, updateItemQuantity)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', settings.cartNoteToggle, toggleCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('keyup', settings.cartNoteTextarea, validateCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', settings.cartNoteTextarea, updateCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', settings.cartNoteSaveButton, updateCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', settings.cartNoteCancelButton, clearCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', settings.cartSubscribeButton, upgradeToSubscription)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('change', settings.cartSubscriptionFrequencySelect, updateItemFrequency)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('keydown', (event) => {
      if (event.key === 'Enter') {
        if (event.target.tagName === 'INPUT') {
          event.target.click()
        }
      }
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('submit', settings.productForm, handleProductSubmit)
  }



  async function getCartJS() {
    const result = await fetch('/cart.json')

    if (result.status === 200) {
      return result.json()
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`)
  }


  function processCheckout(e) {
    e.preventDefault()

    getCart(function (cart) {
      let totalCartValue = 0
      cart.items.forEach(function (item) {
        totalCartValue += item.price
      })
      if (totalCartValue > 0) {
        totalCartValue = parseFloat(totalCartValue / 100)
      }

      location.href = '/checkout'
    })
  }


  function processCartRequest(data, endpoint, callback) {
    var params = {
      url: endpoint,
      data: data,
      method: 'POST',
      dataType: 'json',
      success: function (cart) {
        if (endpoint === urls.cartAdd) {
          // ***GTM DATA LAYER - ADD TO CART***
          try {
            if (cart.items.length) {
              cart = cart.items[0]
            }
          } catch (error) {
            cart = cart
          }

          let isSubcription = false

          try {
            if (cart.selling_plan_allocation) {
              isSubcription = true
            }
          } catch (error) {
            isSubcription = false
          }

          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'acn_add_to_cart',
            event_id: new Date().getTime() + '.' + Math.random().toString(36).substring(5),
            ecommerce: {
              currency: 'USD',
              value: parseFloat(cart.price / 100),
              itemIsSubscription: isSubcription,
              items: [
                {
                  item_id: cart.variant_id,
                  shopify_product_id: cart.product_id,
                  shopify_variant_id: cart.variant_id,
                  shopify_sku: cart.sku,
                  shopify_handle: cart.handle,
                  shopify_compare_price: parseFloat(cart.discounted_price / 100),
                  item_name: cart.product_title,
                  affiliation: cart.vendor,
                  currency: 'USD',
                  item_brand: cart.vendor,
                  item_category: cart.product_type,
                  item_list_id: 'product',
                  item_list_name: 'product',
                  item_variant: cart.variant_title,
                  item_featured_image: cart.image,
                  option_one: cart.variant_options[0],
                  option_two: cart.variant_options[1],
                  option_three: cart.variant_options[2],
                  price: parseFloat(cart.price / 100),
                  quantity: cart.quantity, //please update with a variable
                },
              ],
            },
          })

          // *** Klaviyo - ADD TO CART ***
          let klaviyoApi = window.klaviyo;
          if (!!klaviyoApi) {
            if (cart) {
              klaviyoApi.push(['track', 'Added to Cart', cart])
            } else if (item) {
              klaviyoApi.push(['track', 'Added to Cart', item])
            }
          } 
        }

        if (callback) {
          callback(cart)
        } else {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')
        }
      },
      error: function ( err ) {
        console.error('request error: ', err)
      }
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(params)
  }


  function toggleCartNote() {
    const $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const openNote = $this.is(':checked')

    const $cartNote = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea)
    let value = $cartNote.val()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextareaWrapper).toggleClass(config.activeClass, openNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea).toggleClass(config.activeClass, openNote)

    if (value.length === 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteLabel).removeClass(config.activeClass, openNote)
    } else {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteLabel).hasClass(config.activeClass)) return

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteLabel).addClass(config.activeClass, openNote)
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteLabel).toggleClass(config.activeClass, openNote)
  }


  function clearCartNote() {
    let $noteTextArea = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea)
    let $noteInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteToggle)
    let $characterTracker = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteCharLimit)

    $noteTextArea.val('').trigger('change')
    $characterTracker.text(0)
    $noteInput.prop('checked', false).trigger('change')
    toggleCartNote()
  }


  function validateCartNote() {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let value = $this.val()
    let $characterTracker = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteCharLimit)

    $characterTracker.text(value.length)
  }


  function updateCartNote() {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let $noteTextArea

    if ($this.is('button')) {
      $noteTextArea = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteLabel).trigger('click')
    } else if ($this.is(settings.cartNoteTextarea)) {
      $noteTextArea = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea)
    } else {
      $noteTextArea = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea)
    }

    let value = $noteTextArea.val()

    let data = {
      note: value,
    }

    processCartRequest(data, urls.cartUpdate, function () {
      if (value.length === 0) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteEditButton).removeClass(config.activeClass)
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteCancelButton).removeClass(config.activeClass)
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteEditButton).addClass(config.activeClass)
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteCancelButton).addClass(config.activeClass)
      }
    })
  }


  function upgradeToSubscription(e) {
    e.preventDefault()

    const $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const { key, quantity, variantId, isSubscriptionItem, defaultSubPlan, recurringRefills } = $this.data()
    let isUpgrading = !$this.prop('checked') && isSubscriptionItem
    let customPropsObj = {}
    
    if (!!recurringRefills) {
      customPropsObj["_recurring_refills"] = JSON.stringify(recurringRefills)
    }
    

    const addData = isUpgrading
      ? // Item is already a Subscription, add OG Product
        {
          items: [
            {
              id: variantId,
              selling_plan: null,
              quantity: quantity,
              properties: customPropsObj
            },
          ],
        }
      : // Item is NOT a Subscription, add Subscription Product
        {
          items: [
            {
              id: variantId,
              selling_plan: defaultSubPlan,
              quantity: quantity,
              properties: customPropsObj
            },
          ],
        }


    const removeData = isUpgrading
      ? // Item is already a Subscription, remove any Sub-based Item
        {
          id: key,
          selling_plan: defaultSubPlan,
          quantity: 0,
        }
      : // Item is NOT a Subscription, remove variantID-based item
        {
          id: key,
          selling_plan: null,
          quantity: 0,
        }   
        
    // Requires two requests
    processCartRequest(addData, '/cart/add.js', function () {
      processCartRequest(removeData, '/cart/change.js', function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')
      })
    })
  }


  function updateItemFrequency(e) {
    const $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const { key, quantity, variantId } = $this.data()

    const addData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          selling_plan: $this.val(),
        },
      ],
    }

    const removeData = {
      updates: {
        [key]: 0,
      },
    }

    processCartRequest(addData, '/cart/add.js', function () {
      processCartRequest(removeData, urls.cartUpdate, function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')
      })
    })
  }


  function adjustItemQuantity() {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let key = $this.data('key')

    let data = {
      updates: {
        [key]: $this.val(),
      },
    }

    getCartJS().then((cart) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null })

      let items = []
      for (var i = cart.items.length - 1; i >= 0; i--) {
        if (cart.items[i].key !== key) {
          continue
        }

        items.push({
          item_id: cart.items[i].id,
          shopify_product_id: cart.items[i].product_id,
          shopify_variant_id: cart.items[i].variant_id,
          shopify_sku: cart.items[i].sku,
          shopify_handle: cart.items[i].handle,
          shopify_compare_price: parseFloat(cart.items[i].discounted_price / 100),
          item_name: cart.items[i].product_title,
          affiliation: cart.items[i].vendor,
          currency: 'USD',
          item_brand: cart.items[i].product_title,
          item_category: cart.items[i].product_type,
          item_list_id: 'product',
          item_list_name: 'cart',
          item_variant: cart.items[i].title,
          item_featured_image: cart.items[i].image,
          option_one: cart.items[i].variant_options[0],
          option_two: cart.items[i].variant_options[1],
          option_three: cart.items[i].variant_options[2],
          price: parseFloat(cart.items[i].price / 100),
          quantity: 0, //double check this
        })
      }

      let eventName = 'acn_add_to_cart'

      if ($this.val() < 1) {
        eventName = 'acn_remove_from_cart'
      }

      let gtmData = {
        event: eventName,
        event_id: new Date().getTime() + '.' + Math.random().toString(36).substring(5),
        ecommerce: {
          currency: 'USD',
          items: items,
        },
      }

      window.dataLayer.push(gtmData)

      processCartRequest(data, urls.cartUpdate, function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')
      })
    })
  }


  function updateItemQuantity() {
    let quantity = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('quantity'))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.itemQuantity).val(quantity).trigger('change')
  }


  function filterAndSerializeData($form) {
    let serializedValues = $form.serializeArray()
    let urlEncodedString = jquery__WEBPACK_IMPORTED_MODULE_0___default().param(serializedValues);

    // Handle any post-processing to serialized data, here

    return urlEncodedString
  }


  function handleProductSubmit(e) {
    e.preventDefault()

    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let data = filterAndSerializeData($this)
    config.$elementToFocusOnCartClose = $this

    console.log("data: ", data)
    processCartRequest(data, urls.cartAdd, () => {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')

      const isOpen = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(config.activeClass)
      if (!isOpen) jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:open')
    })
  }


  function handleItemRemove() {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let key = $this.data('key')

    let data = {
      updates: {
        [key]: 0,
      },
    }

    getCartJS().then((cart) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null })

      let items = []
      for (var i = cart.items.length - 1; i >= 0; i--) {
        if (cart.items[i].key !== key) {
          continue
        }

        items.push({
          item_id: cart.items[i].id,
          shopify_product_id: cart.items[i].product_id,
          shopify_variant_id: cart.items[i].variant_id,
          shopify_sku: cart.items[i].sku,
          shopify_handle: cart.items[i].handle,
          shopify_compare_price: parseFloat(cart.items[i].discounted_price / 100),
          item_name: cart.items[i].product_title,
          affiliation: cart.items[i].vendor,
          currency: 'USD',
          item_brand: cart.items[i].product_title,
          item_category: cart.items[i].product_type,
          item_list_id: 'product',
          item_list_name: 'cart',
          item_variant: cart.items[i].title,
          item_featured_image: cart.items[i].image,
          option_one: cart.items[i].variant_options[0],
          option_two: cart.items[i].variant_options[1],
          option_three: cart.items[i].variant_options[2],
          price: parseFloat(cart.items[i].price / 100),
          quantity: 0, //double check this
        })
      }

      let gtmData = {
        event: 'acn_remove_from_cart',
        event_id: new Date().getTime() + '.' + Math.random().toString(36).substring(5),
        ecommerce: {
          currency: 'USD',
          items: items,
        },
      }
      window.dataLayer.push(gtmData)

      processCartRequest(data, urls.cartUpdate, function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:build')
      })
    })
  }


  function getCart(callback) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(urls.cartGet).then(callback)
  }


  function buildCart() {
    getCart(function (cart) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(`/?sections=${config.cartSectionID}`)
        .then(function (response) {
          if (response[config.cartSectionID]) {
            let $response = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response[config.cartSectionID])
            let $newInnerHTML = $response.find(settings.slideCartInner)

            updateShippingIndicator($newInnerHTML)
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).html($newInnerHTML)

            let truncatedCountHtml = '<span class="truncated-counter">99<span class="super-plus">+</span></span>';
            let normalCountHtml = `<span class="">${cart.item_count}</span>`;
            let displayedCartCount = cart.item_count > 99 ? truncatedCountHtml : normalCountHtml;

            //update any displayed cart count(s)
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartCount)
              .html(displayedCartCount)
              .toggleClass(config.activeClass, cart.item_count > 0)
          }
        })
        .catch(function () {})

      setTimeout(function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeCart).trigger('focus')
      }, 300)
    })
  }


  function toggleCart(e) {
    if (e) e.preventDefault()

    const $triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCart)
    $triggers.toggleClass(config.activeClass)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).toggleClass(config.activeClass)

    const isOpen = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(config.activeClass)
    if (!isOpen) {
      // Cart is mid-close, focus on cart-open
      setTimeout(function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCart).trigger('focus')
      }, 300)
    } else {
      // Cart is mid-open, focus on cart-close
      setTimeout(function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeCart).trigger('focus')
      }, 300)
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).attr('data-scroll-lock', isOpen)
  }


  function updateShippingIndicator($newHTML) {
    let newShippingIndicator = $newHTML.find(settings.shippingIndicatorBar)
    let previousWidth = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.shippingIndicatorBar).data('width')
    let newWidth = newShippingIndicator.data('width')

    newShippingIndicator.css({
      width: previousWidth,
    })

    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.shippingIndicatorBar).css({
        width: newWidth,
      })
    }, 10)
  }
}


/***/ })

}]);